import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule, FormArray  } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../services/user.service';
import { CommonDataService } from '../../services/common-data.service';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-shop-checkout-page',
  templateUrl: './shop-checkout-page.component.html',
  styleUrls: ['./shop-checkout-page.component.scss']
})
export class ShopCheckoutPageComponent implements OnInit {
  
  pageName = "Checkout";
  modelForm: FormGroup;
  filesToUpload: Array<File> = [];

  //mapbox search address stuff
  //mapbox search stuff
  searchForm: FormGroup;
  selectedAddress = [];
  addresses = [];

  query: any;
  showResults = false;
  loading = false;
  doneSearch = false;
  formDetected = false;

  addressObjects = []
  cartItems = []

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService
  ) { 

      $('#loader').show();
      let currentOrder = sessionStorage.getItem('order')
      if(currentOrder && parseInt(currentOrder) > 0) {
        this.modelId = currentOrder
      }
      //lets get the model for this page
      if(parseInt(this.modelId) > 0) {
        this.getOrderDetails()
      }
      else 
        this.getUserProfileDetails()

  }

  localModelDataStorage = false;
  modelName = 'Order';
  modelId = '0';
  modelData: any;
  returnData: any;
  files: any;

  ngOnInit() {

      $('#initialise-page').trigger('click');

      let cartItems = localStorage.getItem("cartItems")
    
      if(cartItems) {
        this.cartItems = JSON.parse(localStorage.getItem("cartItems"))
      } 

      else {
        let h = {
          class: "iziToast-warning",
          title:  "Order:",
          message:  "Your shopping cart is empty!",
          animateInside: !1,
          position: "topRight",
          progressBar: !1,
          icon: "icon-bell",
          timeout: 3200,
          transitionIn: "fadeInLeft",
          transitionOut: "fadeOut",
          transitionInMobile: "fadeIn",
          transitionOutMobile: "fadeOut",
        };
        iziToast.show(h);
  
        this.router.navigate(['/shop/products']);
      }

  	  this.modelForm = this.formBuilder.group({

      email: ['', Validators.required], 
      first_name: ['', Validators.required], 
      last_name: ['', Validators.required], 
      phone: ['', Validators.required], 

      address_1: ['', Validators.required], 
      address_2: ['', Validators.required], 
      city: [''], 
      state: ['' ], 
      postcode: ['', Validators.required], 
      building: ['', Validators.required],
      isshipping: [true],
      lat: ['', Validators.required],
      lng: ['', Validators.required],
      fullAddress: ['', Validators.required],
      ObjectString: ['', Validators.required],
      delivery_post_code: ['', Validators.required],
      delivery_city: ['', Validators.required]

    });
  }

  get f() { return this.modelForm.controls; }

  getUserProfileDetails() {
    this._data.getProfile() 
      .pipe(first())
      .subscribe(
        data => {
          console.log(data);
          this.modelData = data['cover']['model']['modelData']['formFieldsEntities'];

          if(this.localModelDataStorage) {

            localStorage.setItem(this.modelName, JSON.stringify(data['result']['ModelData'])); // save reference data in localStorage+

            this.modelData = JSON.parse(localStorage.getItem(this.modelName));

          }
        },
        error => {

          console.log(error);
          iziToast.success({
            title: 'Error!',
            position: 'topRight',
            icon: 'icon-circle-check',
            message: 'Failed to retrieve profile info.'
        });

        $('#loader').hide();

        },

        () => {
          this.prepopulate();
            $('#loader').hide();
        }
      );
  }

  getOrderDetails() {
    let queryData = new FormData();
    queryData.append('modelName', 'Order');
    queryData.append('mid', this.modelId);

      $('#loader').show();
      //lets get the model for this page
      this._data.getModelData(queryData) 
      .pipe(first())
      .subscribe(
        data => {

          this.modelData = data['covers'][0]['cover']['model']['modelData']['formFieldsEntities'];
          this.loading = false

        },
        error => {

            $('#loader').hide();

        },

        () => {
          this.prepopulate();
          $('#loader').hide();
        }
      );
  }

  prepopulate(){

    for (var key in this.modelData) {  // 'field' is a string

      if (this.modelData[key] instanceof Array || this.modelData[key] instanceof Object) {
    
        var innerModelDataObject;

        if (this.modelData[key] instanceof Object) {
          innerModelDataObject = Object.values(this.modelData[key]);

          var innerModelDataObject2 = this.modelData[key];
          console.log(innerModelDataObject2);

          for (const [objectKey, value] of Object.entries(this.modelData[key])) {
            console.log(`${objectKey} ${value}`); // "a 5", "b 7", "c 9"

            for (const objectfield in this.modelForm.controls) {

              if(this.modelData[key][objectfield] && objectfield != 'collectionWarehousePoints') {
                
                this.modelForm.get(objectfield).setValue(this.modelData[key][objectfield]);
                console.log(objectfield);
              }
    
            }
          }
        }

        //not sure what to do with arrays as yet...

        if (this.modelData[key] instanceof Array) {

          // for (var objectKey in this.modelData[key]) {

          //   alert('value is Array!'+ objectKey);

          // }
        }
        
        
      }

      else {

        for (const field in this.modelForm.controls) {
          // console.log(key)
          if(this.modelData[field]) {

            this.modelForm.get(field).setValue(this.modelData[field]);
            //const control = this.modelForm.get(field); // 'control' is a FormControl
            // console.log(field);
  
            //console.log(control);
          }

        }

      }

    }
}

//mapbox
search(event, i) {
  this.query = event.target['value'];
  this.showResults = true;
  this.loading = true;

  if (this.query.length > 2) {
    var formData = new FormData();
    formData.append('search_term', this.query)
    formData.append('limit', '10')
    formData.append('country', 'za')

    this._data.getAddress(formData).subscribe(
      data => {
      this.addresses[i] = data.data['addresses']
      //console.log('addresses are is: '+JSON.stringify(this.addresses))
      // this.scrollToBottom();
      },
      err => {
        console.log('error')
      },
      () => {}
    );
    this.loading = false;
  }
}

addressSelect (fullAddress, lat, lng, address, i) {

  alert(fullAddress)
  this.showResults = false;
  // this.doneSearch = true;
  // this.searchForm.get('searchable').disable();
  this.selectedAddress[i] = fullAddress;
  this.modelForm.get('lat').setValue(lat);
  this.modelForm.get('lng').setValue(lng);
  this.modelForm.get('fullAddress').setValue(fullAddress);
  this.modelForm.get('ObjectString').setValue(JSON.stringify(address));
  this.modelForm.get('delivery_post_code').setValue(address.postCode);
  this.modelForm.get('delivery_city').setValue(address.town);
}

searchResetOnBackspace (event, i) {
  if (event.keyCode === 8 && this.selectedAddress[i]) { // if you hit backspace and have already selected a result, reset
      console.log('cleansed!');
      this.selectedAddress[i] = event.target['value'];
      this.search(event, i); // repopulate results
  }
};

  onFileChanged(event) {
    //this.files = event.target.files[0];
    //this.modelForm.get('images').setValue(this.files);

    this.filesToUpload = <Array<File>>event.target.files;
  }

  onSubmit() {

    //alert('working magic!')
    $('#buttonText').text('Please Wait...');
    $('#loader').show();

    if (this.modelForm.invalid) {
      console.log('errors are detected');

      $('#buttonText').text('Continue ');
      $('#loader').hide();

      return;
    }

    console.log('Details being saved in the service: '+JSON.stringify(this.modelForm.value))

    this.createModel(); // run combine function
  }

  createModel() {

    let modelObject1 = new FormData();

    modelObject1.append('modelName', this.modelName);
    modelObject1.append('id', this.modelId);
    modelObject1.append('billingInfo-email', this.modelForm.controls['email'].value);
    modelObject1.append('billingInfo-first_name', this.modelForm.controls['first_name'].value);
    modelObject1.append('billingInfo-last_name', this.modelForm.controls['last_name'].value);
    modelObject1.append('billingInfo-phone', this.modelForm.controls['phone'].value);


    modelObject1.append('billingInfo-address_1', this.modelForm.controls['address_1'].value);
    modelObject1.append('billingInfo-address_2', this.modelForm.controls['address_2'].value);
    modelObject1.append('billingInfo-city', this.modelForm.controls['city'].value);
    modelObject1.append('billingInfo-state', this.modelForm.controls['state'].value);
    modelObject1.append('billingInfo-postcode', this.modelForm.controls['postcode'].value);

    modelObject1.append('billingInfo-building', this.modelForm.controls['building'].value);
    // modelObject1.append('isshipping', this.modelForm.controls['isshipping'].value);

    modelObject1.append('shippingAddress-lat', this.modelForm.controls['lat'].value);
    modelObject1.append('shippingAddress-lng', this.modelForm.controls['lng'].value);
    modelObject1.append('shippingAddress-fullAddress', this.modelForm.controls['fullAddress'].value);
    modelObject1.append('shippingAddress-ObjectString', this.modelForm.controls['ObjectString'].value);
    modelObject1.append('shippingAddress-delivery_post_code', this.modelForm.controls['delivery_post_code'].value);
    modelObject1.append('shippingAddress-delivery_city', this.modelForm.controls['delivery_city'].value);
    modelObject1.append('shippingAddress-collection_baundary_name', this.modelForm.controls['delivery_city'].value);

    modelObject1.append('cartItems-products', JSON.stringify(this.cartItems));

    this.updateModel(modelObject1);

  }

  updateModel (modelObject: any) {
    // Initiate new model creation/update method

    this._data.updateModelData(modelObject) 
      .pipe(first())
      .subscribe(
        data => {
 
          this.returnData = data;
          console.log('this is the new model return object: '+JSON.stringify(this.returnData));

          this.modelId = data['result']['id'];
          this.modelData = data['result'];

          //lets create a session variable to track this order
          sessionStorage.setItem('order', this.modelId)

          if(this.localModelDataStorage) {

          	localStorage.setItem(this.modelName, JSON.stringify(data['result']['ModelData'])); // save reference data in localStorage+

          	this.modelData = JSON.parse(localStorage.getItem(this.modelName));

          }
        },
        error => {
          console.log(error);

          $('#buttonText').text('Continue ');
          $('#loader').hide();

        },

        () => {

          let h = {
            class: "iziToast-info",
            title:  "Success:",
            message:  "Your order details updated successfuly",
            animateInside: !1,
            position: "topRight",
            progressBar: !1,
            icon: "icon-bell",
            timeout: 3200,
            transitionIn: "fadeInLeft",
            transitionOut: "fadeOut",
            transitionInMobile: "fadeIn",
            transitionOutMobile: "fadeOut",
          };
          iziToast.show(h);

          $('#buttonText').text('Continue ');
          $('#loader').hide();

          this.router.navigate(['/shop/checkout/shipping']);
        }
      );
  }

}
